import { getAgeReference, isHighConfidence } from 'utils'
import { CsvColumnConfig, Player } from 'types/global'

export const MAX_WATCHLISTS_LENGTH = 50
export const MAX_PLAYERS_PER_WATCHLIST = 200
export const MAX_NAME_LENGTH = 20
export const DESTINATION_WATCHLIST_ID_PARAM = 'destination-watchlist-id'

export const CSV_EXPORT_SCHEMA: CsvColumnConfig<Player>[] = [
  { header: 'First name', key: 'firstName', transformValue: val => val ?? '' },
  { header: 'Last name', key: 'lastName', transformValue: val => val ?? '' },
  { header: 'Gender', key: 'gender', transformValue: val => val ?? '' },
  {
    header: 'City',
    key: 'location',
    transformValue: val => {
      const { city } = val?.main ?? {}
      return city ?? ''
    },
  },
  {
    header: 'State',
    key: 'location',
    transformValue: val => {
      const { state } = val?.main ?? {}
      return state ?? ''
    },
  },
  { header: 'Nationality', key: 'countryCode', transformValue: val => val ?? '' },
  {
    header: 'Age group',
    key: 'age',
    transformValue: (val, item) => getAgeReference(item.age, item.birthYear),
  },
  { header: 'Singles number', key: 'wtnSingles', transformValue: val => val ?? '' },
  { header: 'Doubles number', key: 'wtnDoubles', transformValue: val => val ?? '' },
  {
    header: 'High confidence (verified)',
    key: 'wtnConfidenceSingles',
    transformValue: val => (isHighConfidence(val) ? 'Yes' : ''),
  },
]
